<!-- 菜单：日志配置 /pages/dev/logSwitchManage -->
<template>
  <div class="log-switch-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>日志级别配置：当设置 root 为 OFF 时，会关闭所有未明确配置的包的日志；当设置为 DEBUG 时，会开启所有未明确配置的包的 DEBUG 日志</span>
        <el-button type="primary" size="small" @click="refreshData">
          <i class="el-icon-refresh"></i> 刷新
        </el-button>
      </div>

      <el-table :data="tableData" border v-loading="loading" style="width: 100%">
        <el-table-column prop="module" label="模块名称" align="center" />
        <el-table-column prop="description" label="模块描述" align="center" />
        <el-table-column prop="level" label="日志级别" align="center" width="200">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.level"
              size="mini"
              style="width: 120px"
              @change="handleLevelChange(scope.row)"
            >
              <el-option label="DEBUG" value="DEBUG" />
              <el-option label="INFO" value="INFO" />
              <el-option label="WARN" value="WARN" />
              <el-option label="ERROR" value="ERROR" />
              <el-option label="OFF" value="OFF" />
            </el-select>
          </template>
        </el-table-column>
      </el-table>

      <el-divider content-position="left">快捷操作</el-divider>

      <el-row :gutter="20">
        <el-col :span="6">
          <el-button type="success" size="small" @click="handleAllLevel('DEBUG')" :loading="btnLoading">
            全部设为DEBUG
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="info" size="small" @click="handleAllLevel('INFO')" :loading="btnLoading">
            全部设为INFO
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="warning" size="small" @click="handleAllLevel('WARN')" :loading="btnLoading">
            全部设为WARN
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="danger" size="small" @click="handleAllLevel('ERROR')" :loading="btnLoading">
            全部设为ERROR
          </el-button>
        </el-col>
        <el-col :span="12" style="margin-top: 20px;">
          <el-button type="primary" size="small" @click="handleProductionConfig" :loading="btnLoading">
            一键配置(生产环境)
          </el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { listLogSwitch, updateLogSwitch } from '@/api/dev/logSwitchApi'

export default {
  name: 'LogSwitchManage',
  data() {
    return {
      loading: false,
      btnLoading: false,
      tableData: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await listLogSwitch()
        if (res && res.data) {
          this.tableData = this.parseLogSwitchData(res.data)
        }
      } catch (error) {
        this.$message.error(error.message || '获取日志配置失败')
      } finally {
        this.loading = false
      }
    },
    parseLogSwitchData(data) {
      const moduleMap = {
        all: '所有模块',
        fee: '费用模块',
        store: '商户模块',
        user: '用户模块',
        acct: '账户模块',
        order: '订单模块',
        sql: 'SQL模块'
      }
      return Object.keys(data).map(key => ({
        module: key,
        description: moduleMap[key] || key,
        level: data[key]
      }))
    },
    async handleLevelChange(row) {
      this.btnLoading = true
      try {
        const res = await updateLogSwitch({ packageName: row.module, value: row.level })
        if (res && res.code === 0) {
          this.$message.success('设置成功')
        } else {
          this.$message.error(res.msg || '设置失败')
          this.loadData()
        }
      } catch (error) {
        this.$message.error(error.message || '设置失败')
        this.loadData()
      } finally {
        this.btnLoading = false
      }
    },
    async handleAllLevel(level) {
      const allRow = this.tableData.find(item => item.module === 'all')
      if (allRow) {
        await this.handleLevelChange({ ...allRow, level })
      }
    },
    async handleProductionConfig() {
      this.btnLoading = true
      const productionConfig = {
        root: 'INFO',
        comjava110: 'INFO',
        'com.java110.fee': 'INFO',
        'com.java110.order': 'INFO',
        'org.springframework': 'ERROR',
        'org.mybatis': 'INFO',
        'druid.sql': 'INFO'
      }
      try {
        for (const row of this.tableData) {
          const level = productionConfig[row.module]
          if (level && row.level !== level) {
            row.level = level
            await updateLogSwitch({ packageName: row.module, value: level })
          }
        }
        this.$message.success('生产环境配置成功')
        this.loadData()
      } catch (error) {
        this.$message.error(error.message || '配置失败')
      } finally {
        this.btnLoading = false
      }
    },
    refreshData() {
      this.loadData()
    }
  }
}
</script>

<style scoped>
.log-switch-container {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
  align-items: center;
}
</style>
